const types = {
  SET_RISK_EVALUATION_INFO: 'APISNEEDS/SET_RISK_EVALUATION_INFO',
};

export const initialState = {
  riskEvaluationInfo: null,
};

const ApisNeedsRiskScoringReducer = (state, action) => {
  switch (action.type) {
    case types.SET_RISK_EVALUATION_INFO: {
      const { riskEvaluationInfo } = action.payload;

      return {
        ...state,
        riskEvaluationInfo,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setRiskEvaluationInfo: info => ({
    type: types.SET_RISK_EVALUATION_INFO,
    payload: {
      riskEvaluationInfo: info,
    },
  }),
};

export default ApisNeedsRiskScoringReducer;
